import { AnyAction } from "redux";
import { PagedResponse, QueryParams } from "@ofqual/portal-core/core/types";
import {
  WAIT_ACTIVITIES,
  LOADED_ACTIVITIES,
  LOADING_ACTIVITIES,
  WAIT_THREADS,
  LOADED_THREADS,
  LOADING_THREADS
} from "./constants";
import { Activity } from "../domain/Activity";

export interface ActionPayload<T> extends AnyAction {
  type: string;
  payload: T;
}

export const loadedActivities = (
  resourceId: string,
  response: PagedResponse<Activity>
) => ({
  type: LOADED_ACTIVITIES,
  payload: { resourceId, response },
});

export const loadingActivities = (
  resourceId: string,
  params: QueryParams = {}
) => ({
  type: LOADING_ACTIVITIES,
  payload: { resourceId, params },
});

export const waitActivities = (resourceId: string) => ({
  type: WAIT_ACTIVITIES,
  payload: { resourceId },
});

export const loadedThreads = (
  resourceId: string,
  response: PagedResponse<Activity>
) => ({
  type: LOADED_THREADS,
  payload: { resourceId, response }
});

export const loadingThreads = (resourceId: string) => ({
  type: LOADING_THREADS,
  payload: { resourceId },
});

export const waitThreads = (resourceId: string) => ({
  type: WAIT_THREADS,
  payload: { resourceId },
});
